module.exports = "\n.occupancy-body .row .col-lg-12 {\n    font-size: 12vw;\n}\n\n.occupancy-body .row .col-sm-6 {\n    font-size: 8vw;\n}\n\n.occupancy-title{\n    font-size: 5vw;\n}\n\n.occupancy-body {\n    width: 100%;\n    height: 100%;\n}\n\n.container {\n    background: #BA68C8 !important;\n    color: #FFFFFF !important;\n    width: 100vw;\n    height: 100vh;\n    max-width: none;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/occupancy/occupancy.component.css
// module id = 915
// module chunks = 4